import './App.css';
import  AppRoutes from "./Routes/routes";

function App() {
  return (
    <div className="App">
    <AppRoutes />
    </div>
  );
}

export default App;
